export default __webpack_public_path__ + "static/media/Netflix-clone.82dddeb3.png";